<template>
    <nav class="navbar navbar-expand fixed-top be-top-header">
        <div class="container-fluid">
            <div class="be-navbar-header"><router-link class="navbar-brand" :to="'/'"/></div>

            <div class="be-right-navbar">
                <df-user-nav/>

                <div class="d-flex justify-content-center align-items-center" style="height:60px" v-if="isDemoSystem">
                    <div class="bg-warning text-white p-2">
                        <i class="icon mdi mdi-alert-triangle mr-1"></i>
                        <strong>{{demoMessage}}</strong>
                    </div>
                </div>
<!--
                <ul class="nav navbar-nav float-right be-icons-nav">
                    <df-uploads/>
                </ul>
-->
            </div>
        </div>
    </nav>
</template>

<script>
    import env from '../../mixins/env';
    // import DfUploads from '../blocks/DfUploads';
    import DfUserNav from '../blocks/DfUserNav';

    export default {
        mixins: [env],

        components: { DfUserNav },
    };
</script>
